<nav
  class="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow"
>


  <div
    class="container px-4 mx-auto flex flex-wrap items-center justify-between"
  >
    <div
      class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
    >
      <a
        [routerLink]="['/']"
        class="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
        href="#pablo"
      >
      <img src="assets/imges/BananLogo.svg" alt="" width="100">

      </a>
      <button
        class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
        type="button"
        (click)="setNavbarOpen()"
      >
        <i class="fas fa-bars"></i>
      </button>
    </div>
    <div
      class="lg:flex flex-grow items-center"
      [ngClass]="{ hidden: !navbarOpen, block: navbarOpen }"
      id="example-navbar-warning"
    >

      <ul class="flex flex-col lg:flex-row list-none lg:ml-auto " style="justify-content: center; margin-left: auto; margin-right: auto;">

        <li class="flex items-center">
          <a
            class="hover:text-gray-400 text-blueGray-700 px-3 py-2 flex items-center  text-lg  font-thint"
            [routerLink]="['/']"
            [ngClass]="{'  underline-color': isCurrentRoute('/') }"
          >

            <span class=" inline-block ml-2">Home</span>
          </a>
        </li>

        <li class="flex items-center">
          <a
            class="hover:text-gray-400 text-blueGray-700 px-3 py-2 flex items-center  text-lg  font-thin"
            [routerLink]="['/about']"
            [ngClass]="{'  underline-color': isCurrentRoute('/about') }"
          >

            <span class=" inline-block ml-2"> About Us</span>
          </a>
        </li>
        <li class="flex items-center">
          <a
            class="hover:text-gray-400 text-blueGray-700 px-3 py-2 flex items-center text-lg  font-thint"
            [routerLink]="['/organizations']"
            [ngClass]="{'  underline-color': isCurrentRoute('/organizations') }"
          >

            <span class=" inline-block ml-2">Organizations</span>
          </a>
        </li>
        <li class="flex items-center">
          <a
            class="hover:text-gray-400 text-blueGray-700 px-3 py-2 flex items-center text-lg  font-thint"

            [routerLink]="['/FAQs']"
            [ngClass]="{'  underline-color': isCurrentRoute('/FAQs') }"

          >

            <span class="inline-block ml-2">FAQs</span>
          </a>
        </li>

        <li class="flex items-center">
          <a
            class="hover:text-gray-400 text-blueGray-700 px-3 py-2 flex items-center text-lg  font-thint"
          [routerLink]="['/contact-us']"
          [ngClass]="{'  underline-color': isCurrentRoute('/contact-us') }"
          >

            <span class="inline-block ml-2">Contact Us</span>
          </a>
        </li>


      </ul>
      <!-- <div class="row" *ngIf="!navbarOpen">
        <button (click)="changeLanguage('en')" *ngIf="currentLanguage !== 'en'" class="flex gap-1"> <label class="text-black mt-1"> English</label> <img src="../../../../assets/imges/Globe.svg" alt="" width="25"></button>
        <button (click)="changeLanguage('ar')" *ngIf="currentLanguage !== 'ar'" class="flex gap-1"><label class="text-black mt-1"> عربي</label> <img src=".../../../../../assets/imges/Globe.svg" alt="" width="25"> </button>
      </div> -->

      <!-- <li class="flex items-center" *ngIf="navbarOpen">
        <a
          class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg  font-thin"
           (click)="changeLanguage('en')" *ngIf="currentLanguage !== 'en'"
          >
  
            <span class="inline-block ml-2">English</span>
        </a>
  
        <a
        class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-lg  font-thin"
        (click)="changeLanguage('ar')" *ngIf="currentLanguage !== 'ar'"
        >
  
          <span class="inline-block ml-2">عربي</span>
      </a>
      </li> -->
    </div>
  </div>
</nav>



